import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStoreLocation = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.374 19.997C20.052 19.931 19 18.839 19 17.5C19 18.881 17.881 20 16.5 20C15.119 20 14 18.881 14 17.5C14 18.881 12.881 20 11.5 20C10.119 20 9 18.958 9 17L13 9H25L29 17",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 20V29H20",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31 22C31 25.1 26 30.1 26 30.1C26 30.1 21 25.1 21 22C21 18.8 23.6 17 26 17C28.4 17 31 18.8 31 22Z",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeMiterlimit: 10,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M26 23C26.5523 23 27 22.5523 27 22C27 21.4477 26.5523 21 26 21C25.4477 21 25 21.4477 25 22C25 22.5523 25.4477 23 26 23Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgStoreLocation);
export default ForwardRef;
